module.exports = __webpack_public_path__ + "img/product_app.ef66c869.svg";